import axios from 'axios';

export default async function listMessage(thread) {
  const pollInterval = 2000; // Tempo de espera entre requisições (em milissegundos)
  const maxWaitTime = 60000; // Tempo máximo de polling (1 minuto)

  async function pollForAssistantMessage(elapsedTime = 0) {
    if (elapsedTime >= maxWaitTime) {
      console.error("Tempo limite de 1 minuto atingido sem receber a mensagem completa.");
      return "Nenhuma resposta recebida do assistente em 1 minuto.";
    }

    try {
      const response = await axios.get(
        `https://api.openai.com/v1/threads/${thread}/messages`,
        {
          headers: {
            "Authorization": `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
            "OpenAI-Beta": 'assistants=v2',
            "Content-Type": 'application/json',
          },
        }
      );

      // Verifica se existe pelo menos uma mensagem na resposta
      const firstMessage = response.data?.data?.[0];

      if (firstMessage && firstMessage.role === 'assistant') {
        // Verifica se o conteúdo da mensagem e o texto existem de forma segura
        const messageContent = firstMessage?.content?.[0]?.text?.value;
        
        if (messageContent) {
          // Retorna o texto da mensagem se ele existir
          return messageContent;
        } else {
          console.log("Mensagem do assistente recebida, mas conteúdo ausente.");
          // Continua a busca, mas não lança um erro; só loga
          return new Promise((resolve) => {
            setTimeout(async () => {
              resolve(await pollForAssistantMessage(elapsedTime + pollInterval));
            }, pollInterval);
          });
        }
      } else {
        console.log("Aguardando mensagem do assistente...");
        // Continua a busca, aguardando a próxima tentativa
        return new Promise((resolve) => {
          setTimeout(async () => {
            resolve(await pollForAssistantMessage(elapsedTime + pollInterval));
          }, pollInterval);
        });
      }
    } catch (error) {
      console.error('Erro ao buscar mensagens:', error);
      throw error;
    }
  }

  // Inicia o polling para buscar a mensagem correta
  return await pollForAssistantMessage();
}
